import moment from "moment";

const dateOptions = [
  {
    value: moment().utc().startOf("minutes").subtract(1, "hours"),
    label: "Last hour",
    hourDifference: 1,
  },
  {
    value: moment().utc().startOf("minutes").subtract(24, "hours"),
    label: "Last 24 hours",
    hourDifference: 24,
  },
  {
    value: moment().utc().startOf("day").subtract(7, "days"),
    label: "Last 7 days",
    hourDifference: 168,
  },
  {
    value: moment().utc().startOf("day").subtract(30, "days"),
    label: "Last 30 days",
    hourDifference: 720,
  },
  {
    value: "custom",
    label: "Custom Range",
    hourDifference: 0,
  },
];

export default dateOptions;
